const dailyPrayer = [
  { label: "5 times everyday strictly", value: "5 times everyday strictly" },
  { label: "Few times everyday", value: "Few times everyday" },
  { label: "Only Jumu'ah", value: "Only Jumu'ah" },
  { label: "Only during Ramadan", value: "Only during Ramadan" },
];
export default dailyPrayer;
